define('models/pages/dashboard/sessions',[
    'underscore',
    'chaplin',
    'models/base/model',
    'models/base/collection',
    'lib/utils'
], function(_, Chaplin, Model, Collection) {
    'use strict';

    var SessionsCollection = Collection.extend({
        constructor: function() {
            Collection.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    var SessionsModel = Model.extend({
        defaults: {
            caption: 'Торговые сессии сегодня'
        },
        constructor: function(data) {
            Model.apply(this, arguments);
            this.items = new SessionsCollection(data ? data.items : [], { parse: true });
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.items.dispose();
            Model.prototype.dispose.apply(this, arguments);
        },
        parse: function(data) {
            this.items.reset(data.items);
            return data;
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            return params;
        }
    });

    return SessionsModel;
});
